import { FC } from "react";

import __ from "web/Layout/Translations";

import Field from "web/Components/Common/Form/Field";
import Select from "web/Components/Common/Form/Select";

import TrashIcon from "web/assets/icons/trash.svg";

import { RentableGroupCalculatorCopy } from "../const/rentableGroupCalculatorCopy";
import peopleOptions from "../const/rentableGroupCalculatorPeopleOptions";
import RentableGroupCalculatorHtmlContent from "../RentableGroupCalculatorHtmlContent";
import classes from "./rentableGroupCalculatorPerson.scss";

const peopleMap = {
  me: "Ja",
  partner: "Małżonek/Partner",
  child: "Dziecko",
  other: "Inna osoba",
};

interface IRentableGroupCalculatorPersonProps {
  personRole: string;
  isSelectDisabled?: boolean;
  onRemove?: () => void;
  selectName: string;
  inputName: string;
  calculatorCopy: RentableGroupCalculatorCopy;
}

const RentableGroupCalculatorPerson: FC<
  IRentableGroupCalculatorPersonProps
> = ({
  personRole,
  selectName,
  inputName,
  calculatorCopy,
  isSelectDisabled = false,
  onRemove,
}) => {
  const { removePerson, personInHousehold, incomeInHousehold } = calculatorCopy || {};
  const incomeLabelId = `${inputName}-label`;

  return (
    <div className={`${classes.root} ${onRemove ? "" : classes.noRemoveBtn}`}>
      <div className={classes.inputWrapper}>
        <div className={classes.selectWrapper}>
          <RentableGroupCalculatorHtmlContent
            as="h4"
            className={classes.fieldLabel}
            html={personInHousehold}
          />
          <Select
            options={peopleOptions}
            placeholder={peopleMap[personRole as keyof typeof peopleMap]}
            name={selectName}
            classes={{ selectRoot: classes.select }}
            isDisabled={isSelectDisabled}
            shouldTranslateLabel
          />
        </div>

        <div className={classes.incomeInputWithLabelWrapper}>
          <RentableGroupCalculatorHtmlContent
            as="div"
            id={incomeLabelId}
            className={classes.fieldLabel}
            html={incomeInHousehold}
          />
          <div className={classes.incomeInputWrapper}>
            <Field
              name={inputName}
              id={inputName}
              aria-labelledby={incomeLabelId}
              type="number"
              validationRules={[
                "required",
                "lessThanMax",
                "maxTwoDecimalPlaces",
              ]}
            />
            <span className={classes.currency}>{__("zł")}</span>
          </div>
        </div>
      </div>

      {onRemove && (
        <div className={classes.btnWrapper}>
          <button
            className={classes.removeBtn}
            type="button"
            onClick={onRemove}
          >
            <TrashIcon width={16.5} />
            <RentableGroupCalculatorHtmlContent
              as="span"
              className={classes.removeBtnText}
              html={__(removePerson)}
            />
          </button>
        </div>
      )}
    </div>
  );
};
export default RentableGroupCalculatorPerson;
